import { useEffect, useState } from "react";
import API from "@src/API.js";
import CustomButton from "../Controls/CustomButton";
import { toast } from "react-toastify";

export default function SupervisorEvalPanel() {
  const [pending, setPending] = useState([]);
  const [active, setActive] = useState(null);
  const [score, setScore] = useState(5);
  const [comments, setComments] = useState("");
  const [busy, setBusy] = useState(false);

  async function load() {
    const resp = await API.getAsync("/SupervisorEval/Pending");
    if (resp?.ok) setPending(resp.jsonData || []);
  }

  useEffect(() => {
    load();
  }, []);

  async function submit(skip) {
    if (!active || busy) return;
    setBusy(true);
    try {
      const payload = {
        PromptID: active.ID ?? active.id,
        Skip: !!skip,
        Score: skip ? null : Number(score),
        Comments: skip ? null : comments || null,
      };
      const resp = await API.postAsync("/SupervisorEval", payload);
      if (!resp?.ok) {
        toast.error(resp?.jsonData?.message || "Evaluation save failed");
        return;
      }
      toast.success(skip ? "Evaluation skipped" : "Evaluation saved");
      setActive(null);
      await load();
    } finally {
      setBusy(false);
    }
  }

  if (!pending.length && !active) return null;

  return (
    <div className="tabsection" data-testid="supervisor-eval-panel">
      <div className="listTitle">
        <span>Supervisor evaluations</span>
      </div>
      {!active ? (
        <ul data-testid="supervisor-eval-pending-list">
          {pending.map((p) => {
            const id = p.ID ?? p.id;
            const name = p.ToPersonName ?? p.toPersonName ?? "colleague";
            return (
              <li key={id}>
                <CustomButton
                  type="button"
                  variant="contained"
                  color="primary"
                  data-testid={`supervisor-eval-open-${id}`}
                  onClick={() => {
                    setActive(p);
                    setScore(5);
                    setComments("");
                  }}
                >
                  Evaluate {name}
                </CustomButton>
              </li>
            );
          })}
        </ul>
      ) : (
        <div data-testid="supervisor-eval-form">
          <p>
            Rate {active.ToPersonName ?? active.toPersonName ?? "colleague"} (1–5)
          </p>
          <label>
            Score
            <select
              data-testid="supervisor-eval-score"
              value={score}
              onChange={(e) => setScore(e.target.value)}
            >
              {[1, 2, 3, 4, 5].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
          <label>
            Comments
            <textarea
              data-testid="supervisor-eval-comments"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              rows={3}
            />
          </label>
          <div>
            <CustomButton
              type="button"
              variant="contained"
              color="primary"
              data-testid="supervisor-eval-submit"
              disabled={busy}
              onClick={() => submit(false)}
            >
              Submit
            </CustomButton>
            <CustomButton
              type="button"
              variant="outlined"
              color="secondary"
              data-testid="supervisor-eval-skip"
              disabled={busy}
              onClick={() => submit(true)}
            >
              Skip
            </CustomButton>
            <CustomButton type="button" variant="outlined" color="secondary" disabled={busy} onClick={() => setActive(null)}>
              Cancel
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
}
